import React from 'react';
import { Link } from 'react-router-dom';
import { CUSTOMER_POLICY_ROUTES } from '../data/customerPolicies';
import '../styles/TravelTerms.css';

const CARDS = [
  {
    icon: 'fa-tag',
    title: 'Transparent Pricing',
    text: 'Estimated fare uses billing distance, the published vehicle rate, and driver bata. Extra charges are explained when they apply.',
  },
  {
    icon: 'fa-calendar',
    title: 'Booking & Cancellation',
    text: 'A booking is a request until EasyDropTaxi confirms it. Cancellation depends on driver assignment and trip status.',
  },
  {
    icon: 'fa-shield',
    title: 'Travel Safety',
    text: 'Driver identity and vehicle number are verified, and emergency support is available 24/7.',
  },
  {
    icon: 'fa-user',
    title: 'Passenger Guidelines',
    text: 'No smoking or alcohol in the vehicle. Please respect the driver and keep the cab clean.',
  },
];

const POLICY_LINKS = [
  { to: CUSTOMER_POLICY_ROUTES.fare, label: 'Fare & Payment Policy' },
  { to: CUSTOMER_POLICY_ROUTES.booking, label: 'Booking Policy' },
  { to: CUSTOMER_POLICY_ROUTES.cancellation, label: 'Cancellation & Refund Policy' },
  { to: CUSTOMER_POLICY_ROUTES.privacy, label: 'Privacy Policy' },
];

const TravelTerms = () => {
  return (
    <section className="travel-confidence block-space" aria-labelledby="travel-confidence-heading">
      <div className="container">
        <h2 id="travel-confidence-heading" className="confidence-title">Travel with Confidence</h2>
        <p className="confidence-subtitle">Clear fares. Reliable service. Transparent travel policies.</p>

        <div className="confidence-grid">
          {CARDS.map((card) => (
            <article key={card.title} className="confidence-card">
              <i className={`fa ${card.icon}`} aria-hidden="true"></i>
              <h3>{card.title}</h3>
              <p>{card.text}</p>
            </article>
          ))}
        </div>

        <div className="confidence-actions">
          <Link className="confidence-cta" to={CUSTOMER_POLICY_ROUTES.terms}>
            Read Full Travel Terms &amp; Conditions
          </Link>
          <p className="confidence-links">
            {POLICY_LINKS.map((item, index) => (
              <React.Fragment key={item.to}>
                {index > 0 ? <span aria-hidden="true"> · </span> : null}
                <Link to={item.to}>{item.label}</Link>
              </React.Fragment>
            ))}
          </p>
        </div>
      </div>
    </section>
  );
};

export default TravelTerms;
